import { useClickOutside } from 'hooks/useClickOutside'
import clsx from 'clsx'
import icEyeOpen from '../../../assets/images/ic-eye-open.svg'
import Popup from '../popup'
import icX from '../../../assets/images/ic-x.svg'
import RadioButton from '../radio-button'
import { Button } from 'avo-ui'
import { useState } from 'react'

const PAGE_LIMIT = [
    {
        label: 'Show 20 Items',
        key: 20,
        name: 'page-limit',
    },
    {
        label: 'Show 50 Items',
        key: 50,
        name: 'page-limit',
    },
    {
        label: 'Show 100 Items',
        key: 100,
        name: 'page-limit',
    },
    {
        label: 'Show 250 Items',
        key: 250,
        name: 'page-limit',
    },
]

const PageLimit = ({ className, classNamePopup, name = 'page-limit', value, onSelect }) => {
    const [show, setShow] = useState(false)

    const getLabel = () => {
        const findData = PAGE_LIMIT?.find((item) => Number(value) === item?.key)
        return findData?.label
    }

    const onSelectOption = (value) => {
        if (onSelect) onSelect(value)
        setShow(false)
    }

    useClickOutside({
        callback: () => setShow(false),
        elementID: `page-limit-${name}`,
    })

    return (
        <div id={`page-limit-${name}`} className={clsx('relative', className)}>
            <Button
                title={getLabel() || 'Show Items'}
                icon={icEyeOpen}
                type={'outline'}
                onClick={() => setShow(!show)}
            />
            <Popup
                className={clsx('top-11 p-4', classNamePopup)}
                show={show}
                content={
                    <div className={'flex flex-col space-y-6'}>
                        <div className={'flex justify-between'}>
                            <div />
                            <p className={'font-semibold'}>Show Items</p>
                            <img
                                className={'w-5 -mt-2 cursor-pointer'}
                                src={icX}
                                alt='ic-x'
                                onClick={() => setShow(false)}
                            />
                        </div>
                        <div className={'flex flex-col space-y-4'}>
                            {PAGE_LIMIT.map((item) => (
                                <RadioButton
                                    key={item?.key}
                                    label={item?.label}
                                    name={item?.name}
                                    value={item?.key}
                                    checked={Number(value) === item?.key}
                                    onChange={({ value }) => onSelectOption(value)}
                                />
                            ))}
                        </div>
                    </div>
                }
            />
        </div>
    )
}

export default PageLimit
